import { createPinia } from 'pinia';
import useAppStore from './modules/app';
import useUserStore, { ensureUserHydrated } from './modules/user';

const pinia = createPinia();

export { ensureUserHydrated, useAppStore, useUserStore };

export default pinia;
